<!--
Created on 2021-04-15
Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
Proprietary and confidential
Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-15
-->
<template>
  <div id="page">
    <!-- header and footer bar go here-->
    <div class="header header-fixed header-auto-show header-logo-app">
        <a href="#" data-back-button class="header-title header-subtitle">Back</a>
        <a href="#" data-back-button class="header-icon header-icon-1"><i class="fas fa-arrow-left"></i></a>
        <a href="#" data-toggle-theme class="header-icon header-icon-3 show-on-theme-dark"><i class="fas fa-sun"></i></a>
        <a href="#" data-toggle-theme class="header-icon header-icon-3 show-on-theme-light"><i class="fas fa-moon"></i></a>
        <a href="#" data-menu="menu-main" class="header-icon header-icon-2"><i class="fas fa-bars"></i></a>
    </div>

    <footer-bar activeItem="database" />

    <div class="page-content">
        <div class="page-title page-title-small">
            <h2><a href="#" data-back-button><i class="fa fa-arrow-left"></i></a>Databáza</h2>
            <a href="#" data-menu="menu-main" class="bg-fade-highlight-light shadow-xl preload-img" data-src="images/avatars/5s.png"></a>
        </div>
        <div class="card header-card shape-rounded" data-card-height="150">
            <div class="card-overlay bg-highlight opacity-95"></div>
            <div class="card-overlay dark-mode-tint"></div>
            <div class="card-bg preload-img" data-src="images/pictures/20s.jpg"></div>
        </div>

        <database-card @onStartSync="startSync()" :key="dataCardKey" />

        <div class="card card-style">
          <div class="content mb-2">
              <h3>Aktuálne informácie</h3>
              <p class="mb-2">
                Posledná synchronizácia: <span class="color-blue-light">{{ lastSyncTime }}</span>
              </p>
              <data-counters-table :key="dataCardKey" />
          </div>
      </div>     

      <!-- card auto sync -->
        <div class="card card-style">
          <div class="content">
              <h3>Automatická synchronizácia</h3>
              <p>
                  Tu je možné vypnúť automatickú synchronizáciu databázy. Čo to znamená? V prípade ak je automatická synchronizácia zapnutá, pri každom možnom pripojení do siete internet sa na pozadí databáza automaticky zosynchronizuje so servermi Dr Theiss a nahrajú sa Vaše vytvorené objednávky a stiahnú aktuálne dáta a podobne.
              </p>
              <div class="d-flex no-effect" 
                   data-trigger-switch="toggle-id-1" 
                   data-bs-toggle="collapse" 
                   href="#collapseExample1" 
                   role="button" 
                   aria-expanded="false" 
                   aria-controls="collapseExample1">
                  <div class="pt-2 mt-1">
                      <h5 class="font-600 font-14">Automatická synchronizácia</h5>
                  </div>
                  <div class="ms-auto me-4 pe-2">
                      <div class="custom-control ios-switch">
                          <input type="checkbox" class="ios-input" id="toggle-id-1" v-model="isAutoSyncEnabled">
                          <label class="custom-control-label" for="toggle-id-1"></label>
                      </div>
                  </div>
              </div>
              <div class="collapse" id="collapseExample1">
                  <p class="mb-0 pb-0 pt-2">Synchronizácia je zapnutá.</p>
              </div>
          </div>
        </div>

        <div class="card card-style bg-red-dark">
          <div class="content p-2">
            <h3>Inicializácia databázy</h3>
            <p class="text-white">
              Po manuálnej inicializácií budú zmazané všetky Vami uložené dáta, ktoré ešte neboli synchronizované a následne sa stiahne posledná aktualizácia dát.
            </p>
            <div @click="startInit()" class="btn btn-m mt-2 mb-2 btn-full bg-white color-red-dark rounded-sm text-uppercase font-900"><i v-if="syncLoading" class="fa fa-sync fa-spin me-3"></i>Inicializácia</div>
          </div>
        </div>

        <!-- back to top -->
        <div class="content mt-5 mb-5">
          <a href="#" class="back-to-top-badge bg-highlight shadow-xl"><i class="fa fa-caret-up"></i><span>Back to Top</span></a>
        </div>
            
        <!-- footer and footer card-->
        <footer-card class="footer" />
    </div>    
    <!-- end of page content-->
    
    <main-menu />
    <dr-theiss-page-modal />
    <success-modal :message="successMesage" :title="successTitle" />
    <error-modal v-model="errorMesage" />
    <confirm-modal title="Naozaj inicializovať?" messageHtml="Pred inicializáciou budú<br><b>všetky dáta vymazané:</b><br>databáza, objednávky a podobne.<br>Naozaj sa chcete spustiť inicializáciu?" btnTitle="áno" @onConfirm="initDatabase()" />
    <sync-modal @onFinish="onSync" ref="syncModalRef" />
  </div>
</template>

<script>
import { ref, inject } from 'vue'
import util from '@/lib/util'
import MainMenu from '@/components/menus/MainMenu'
import ErrorModal from '@/components/modals/ErrorModal'
import SuccessModal from '@/components/modals/SuccessModal'
import storage from '@/lib/storage'
import ConfirmModal from '@/components/modals/ConfirmModal.vue'
import DrTheissPageModal from '@/components/modals/DrTheissPageModal'
import FooterBar from '@/components/bars/FooterBar'
import FooterCard from '@/components/cards/FooterCard'
import DatabaseCard from '@/components/cards/DatabaseCard'
import DataCountersTable from '@/components/tables/DataCountersTable'
import SyncModal from '@/components/modals/SyncModal'

export default {
  name: 'Database',
  components: {
    FooterBar,
    FooterCard,
    DrTheissPageModal,
    MainMenu,
    DatabaseCard,
    ErrorModal,
    SuccessModal,
    SyncModal,
    ConfirmModal,
    DataCountersTable
  },
  setup() {
    const isAutoSyncEnabled = ref(storage.getSettings('isAutoSyncEnabled', { value: false }).value || false)
    const lastSyncTime = ref(util.getLastSyncText((storage.getSettings('lastSyncTime') || {}).value))
    const appProps = inject('appProps')
    const successMesage = ref('')
    const errorMesage = ref('')
    const successTitle = ref('')
    const dataCardKey = ref(0)
    const syncLoading = ref(false)
    const syncModalRef = ref(null)

    function onSync (noUpload) {
      if (noUpload === true) {
        successTitle.value = 'Inicializovaná'
        successMesage.value = 'Databáza bola úspešne inicializovaná.'
      } else {
        successTitle.value = 'Synchronizované'
        successMesage.value = 'Databáza bola úspešne sychronizovaná.'
      }
      dataCardKey.value++
      appProps.$openSuccessModal()
      lastSyncTime.value = util.getLastSyncText((storage.getSettings('lastSyncTime') || {}).value)
      syncLoading.value = false
    }

    function startSync () {
      appProps.$openSyncModal()
      syncModalRef.value.startSync()
    }

    function startInit () {
      appProps.$openConfirmModal()
    }

    function initDatabase () {
      syncLoading.value = true
      setTimeout(() => {
        appProps.$openSyncModal()
        syncModalRef.value.startSync(true)
      }, 200)
    }

    return {
      successMesage,
      startSync,
      syncModalRef,
      errorMesage,
      successTitle,
      isAutoSyncEnabled,
      appProps,
      lastSyncTime,
      onSync,
      syncLoading,
      startInit,
      initDatabase,
      dataCardKey
    }
  },
  mounted() {
    setTimeout(() => {
      document.init_event()
    })
  },
  watch: {
    isAutoSyncEnabled: function (value) {
      storage.setSettings('isAutoSyncEnabled', { value })
    },
  }
}
</script>
